import { action, computed } from 'mobx';
import { processDefinitionManagerApi } from 'src/services/apiServices';
import { ProcessName } from 'src/types/processName';
import { EntityProvider } from 'src/utils/EntityProvider';
import { AsyncOperationWithStatus } from 'src/utils/mobx/AsyncOperationWithStatus';
import { RequestHelper } from 'src/utils/RequestHelper';

export class ProcessStoreClass<T extends Record<string, any>> {
    submitProcessLoader = new AsyncOperationWithStatus((data: T) => {
        return RequestHelper.unwrapFromAxiosPromise(
            processDefinitionManagerApi.submitStartFrom({
                key: this.key,
                requestBody: data,
            }),
        );
    });

    constructor(private key: ProcessName) {}

    @action async submit(data: T) {
        await this.submitProcessLoader.call(data);

        return this.submitProcessLoader.data;
    }

    @computed get nextTasks(): Array<any> | undefined {
        return this.submitProcessLoader.data;
    }
}

export const ProcessStoreProvider = new EntityProvider<
    ProcessName,
    ProcessStoreClass<any>
>(ProcessStoreClass<any>);
